import { useState } from 'react';
import { CardContent, Link, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import type { CustomerDataItem } from '@shared/api';
import { RoutePaths } from '@shared';
import { DelayedLinearProgress, RouterNavLink } from '@widgets';

interface Props {
  loading: boolean;
  data?: CustomerDataItem[];
}

export const CustomersTable = (props: Props) => {
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  if (props.loading) {
    return (
      <CardContent style={{ textAlign: 'center' }}>
        <DelayedLinearProgress />
      </CardContent>
    );
  }
  if (!props.data || props.data.length === 0) {
    return (
      <CardContent style={{ textAlign: 'center' }}>
        <Typography align='center'>
          No data to display.
          <br />
          Start by performing a search.
        </Typography>
      </CardContent>
    );
  }
  return (
    <>
      <Table aria-label='simple table' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Full Name</TableCell>
            <TableCell style={{ width: '150px' }} align='center'>
              Passport/ID
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
            <TableRow key={i}>
              <TableCell>
                <Link component={RouterNavLink} to={RoutePaths.customersDetails.onNavigate(row.customer.id)} color='primary'>
                  {row.customer.fullname}
                </Link>
              </TableCell>
              <TableCell align='center'> {row.customer.passport}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component='div'
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, value) => setPage(value)}
        onRowsPerPageChange={(e) => {
          setPage(0);
          setRowsPerPage(+e.target.value);
        }}
      />
    </>
  );
};
